import React, { useState, useEffect } from "react";
import cn from "classnames";
import loginIcon from "../images/header/log-in.svg";

const Header = ({ baseUrl, siteUrl }) => {
  const [isMenuOpen, setOpenMenu] = useState(false);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
      document.querySelector(".modal__menu-wr").style.overflow = "auto";
      return;
    }
    document.body.style.overflow = "unset";
  }, [isMenuOpen]);

  const handleClick = () => {
    setOpenMenu(!isMenuOpen);
  };

  const renderModalMenu = () => {
    return (
      <div className="modal__menu">
        <div className="modal__menu-container">
          <div className="modal__menu-buttons">
            <a href={`${siteUrl}signup`}>
              <button className="purple-button">Попробовать бесплатно</button>
            </a>
            <a href={`${siteUrl}auth`}>
              <button className="modal__menu-signin">
                Войти
                <img src={loginIcon} alt="" />
              </button>
            </a>
          </div>
        </div>

        <div className="modal__menu-footer">
          <div className="modal__menu-footer-label">Служба поддержки:</div>
          <a className="modal__menu-footer-phone" href="tel:88003500335">
            8 800 350-03-35
          </a>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
        <header className="header__wrapper">
          <div className="header">
            <div
              className={cn("header__menu-mobile", {
                "header__menu-open": isMenuOpen,
              })}
              onClick={handleClick}
            />
            <a href={`${siteUrl}myeducation`} className="header__wrapper__logo">
              <div className="header__logo"/>
            </a>
            <div className="header__auth">
              <a href={`${siteUrl}signup`} className="header__link">
                <button className="purple-button">Попробовать бесплатно</button>
              </a>
              <a href={`${siteUrl}auth`} className="header__link header__signin">
                Войти
              </a>
            </div>
            <a href={`${siteUrl}auth`} className="header__auth-mobile"/>
          </div>
          <div
            className={cn("modal", {
              active: isMenuOpen,
            })}
          >
            <div className="modal__overlay">
              <div className="modal__menu-wr">
                <div className="modal__content-container">{renderModalMenu()}</div>
              </div>
            </div>
          </div>
        </header>
    </React.Fragment>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./app/frontend/components/Header.js